import { useMemo } from 'react';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import DonationFormRequiredField from '@/donationPages/_dependencies/components/DonationFormRequiredField';
function useRequiredComponent(required) {
  const FieldComponent = required ? DonationFormRequiredField : DonationFormField;
  return FieldComponent;
}
export default useRequiredComponent;